<template>
  <apexchart
    :options="pieChartOptions()"
    :series="pieSeries"
  />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class extends Vue {
  @Prop({ required: true }) private pieSeries!: Array<number>
  @Prop({ required: true }) private pieChartSize!: number

  private pieChartOptions() {
    return {
      chart: {
        width: this.pieChartSize,
        height: this.pieChartSize,
        type: 'pie',
        animations: {
          enabled: false
        },
        dropShadow: {
          enabled: true,
          top: 3,
          left: 0,
          blur: 4,
          color: '#000',
          opacity: 0.2
        }
      },
      legend: { show: false },
      dataLabels: { enabled: false },
      colors: ['hsl(0, 100%, 50%)', 'hsl(47, 100%, 50%)', 'hsl(161, 67%, 47%)'],
      plotOptions: {
        pie: {
          expandOnClick: false
        }
      },
      stroke: { show: true, width: 0 },
      tooltip: {
        enabled: false
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0
          }
        },
        hover: {
          filter: {
            type: 'none',
            value: 0
          }
        },
        active: {
          filter: {
            type: 'none',
            value: 0
          }
        }
      }
    }
  }
}
</script>
